import React from 'react';
import FindAccountForm from './FindAccountForm/FindAccountForm.jsx';
import { observer } from 'src/utils/mobx-react';
import { CustomersList } from './CustomersList';
import { useCommon } from 'src/AppState/Common';
import { CustomersListState } from 'src/AppState/CustomersListState/CustomersListState';

export const FindAccountTab = observer('FindAccountTab', () => {
    const common = useCommon();
    const { onSearch } = CustomersListState.get(common);

    return (
        <div className='find-account-tab'>
            <FindAccountForm onSubmit={onSearch} />
            <CustomersList />
        </div>
    );
});
